import { render, staticRenderFns } from "./RequestPasswordResetForm.vue?vue&type=template&id=3f72263d&scoped=true"
import script from "./RequestPasswordResetForm.vue?vue&type=script&lang=js"
export * from "./RequestPasswordResetForm.vue?vue&type=script&lang=js"
import style0 from "./RequestPasswordResetForm.vue?vue&type=style&index=0&id=3f72263d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f72263d",
  null
  
)

export default component.exports